
import { LinkedinOutlined } from '@ant-design/icons';
import { Modal, Divider, Row, Progress, Drawer, Card, Button, } from 'antd';
import Meta from 'antd/es/card/Meta';
import * as React from 'react';
import { L } from '../../../../lib/abpUtility';
import { MoreInfoData } from '../../../EntityConfigs/moreInfoData';

export interface IOurTeamProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    location: any;
    onCancel: () => void;
    onLogin: (values: any) => void;
}

export interface IOurTeamState {
    loading: boolean;
    modalDrawerVisible: boolean;
    subDrawerVisible: boolean;
    currentInfoEmail: string;
    currentInfoName: string;
    currentInfoImage: string;
    currentInfoText: string;
    currentInfoTitle: string;
}

class OurTeam extends React.Component<IOurTeamProps, IOurTeamState> {
    state = {
        loading: false,
        modalDrawerVisible: false,
        subDrawerVisible: false,
        currentInfoName: '',
        currentInfoImage: '',
        currentInfoText: '',
        currentInfoTitle: '',
        currentInfoEmail: ''
    };

    handleMoreInfo(name: any) {

        if (name === MoreInfoData.name_Ben) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Ben, currentInfoTitle: MoreInfoData.title_Ben, currentInfoName: MoreInfoData.name_Ben, currentInfoImage: MoreInfoData.image_Ben, currentInfoText: MoreInfoData.info_Ben });
        }
        else if (name === MoreInfoData.name_Bill) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Bill, currentInfoTitle: MoreInfoData.title_Bill, currentInfoName: MoreInfoData.name_Bill, currentInfoImage: MoreInfoData.image_Bill, currentInfoText: MoreInfoData.info_Bill });
        }
        else if (name === MoreInfoData.name_Chi) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Chi, currentInfoTitle: MoreInfoData.title_Chi, currentInfoName: MoreInfoData.name_Chi, currentInfoImage: MoreInfoData.image_Chi, currentInfoText: MoreInfoData.info_Chi });
        }
        else if (name === MoreInfoData.name_Jeff) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Jeff, currentInfoTitle: MoreInfoData.title_Jeff, currentInfoName: MoreInfoData.name_Jeff, currentInfoImage: MoreInfoData.image_Jeff, currentInfoText: MoreInfoData.info_Jeff });
        }
        else if (name === MoreInfoData.name_Mitch) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Mitch, currentInfoTitle: MoreInfoData.title_Mitch, currentInfoName: MoreInfoData.name_Mitch, currentInfoImage: MoreInfoData.image_Mitch, currentInfoText: MoreInfoData.info_Mitch });
        }
        else if (name === MoreInfoData.name_Paul) {
            this.setState({ currentInfoEmail: MoreInfoData.email_Paul, currentInfoTitle: MoreInfoData.title_Paul, currentInfoName: MoreInfoData.name_Paul, currentInfoImage: MoreInfoData.image_Paul, currentInfoText: MoreInfoData.info_Paul });
        }

        if (this.props.isMobile === true) {
            this.setState({ subDrawerVisible: true })
        }
        else {
            this.setState({ modalDrawerVisible: true })
        }

    }

    render() {
        const { visible, isMobile, onCancel } = this.props;

        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        footer={null}
                        onCancel={onCancel}
                        width={730}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Our Team')}
                        </Divider>
                        <Row style={{ marginBottom: '0px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                        <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    



                            <div style={{ width: '100%', margin: 'auto', textAlign: 'center' }}>

                                <Card
                                    style={{ float: 'left', marginLeft: '10px', width: '200px', marginTop: '10px' }}
                                    cover={<div>    <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                        {MoreInfoData.title_Ben}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Ben}
                                            src={MoreInfoData.image_Ben}

                                        />
                                    </div>
                                    }


                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Ben)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Ben, "_blank")} />,
                                    ]}
                                >


                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{
                                            marginBottom: '-8px',
                                            fontSize: '1.3em', opacity: '0.8'
                                        }}
                                            className="font-face-gm">{MoreInfoData.name_Ben}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Ben, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray',
                                                marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Ben}
                                        </Button>}
                                    />
                                </Card>


                                <Card
                                    style={{ float: 'left', marginLeft: '12px', width: '200px', marginTop: '10px' }}
                                    cover={<div>  <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px' }}>
                                        {MoreInfoData.title_Mitch}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Mitch}
                                            src={MoreInfoData.image_Mitch}

                                        /> </div>
                                    }
                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Mitch)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Mitch, "_blank")} />,
                                    ]}
                                >
                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{ marginBottom: '-8px', fontSize: '1.3em', opacity: '0.8' }} className="font-face-gm">{MoreInfoData.name_Mitch}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Mitch, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Mitch}
                                        </Button>}
                                    />
                                </Card>

                                <Card
                                    style={{ float: 'left', width: '200px', marginLeft: '12px', marginTop: '10px' }}
                                    cover={<div>    <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px' }}>
                                        {MoreInfoData.title_Bill}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Bill}
                                            src={MoreInfoData.image_Bill}
                                        />  </div>
                                    }
                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Bill)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Bill, "_blank")} />,
                                    ]}
                                >
                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{ marginBottom: '-8px', fontSize: '1.3em', opacity: '0.8' }}
                                            className="font-face-gm">{MoreInfoData.name_Bill}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Bill, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Bill}
                                        </Button>}
                                    />
                                </Card>
                                <br />



                                <Card
                                    style={{ float: 'left', width: '200px', marginLeft: '10px', marginTop: '10px' }}
                                    cover={<div>    <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px' }}>
                                        {MoreInfoData.title_Paul}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Paul}
                                            src={MoreInfoData.image_Paul}

                                        />  </div>
                                    }
                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Paul)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Paul, "_blank")} />,
                                    ]}
                                >
                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{ marginBottom: '-8px', fontSize: '1.3em', opacity: '0.8' }}
                                            className="font-face-gm">{MoreInfoData.name_Paul}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Paul, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Paul}
                                        </Button>}
                                    />
                                </Card>


                                <Card
                                    style={{ float: 'left', width: '200px', marginLeft: '12px', marginTop: '10px' }}
                                    cover={<div>    <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px' }}>
                                        {MoreInfoData.title_Jeff}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Jeff}
                                            src={MoreInfoData.image_Jeff}

                                        /></div>
                                    }
                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Jeff)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Jeff, "_blank")} />,
                                    ]}
                                >
                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{ marginBottom: '-8px', fontSize: '1.3em', opacity: '0.8' }}
                                            className="font-face-gm">{MoreInfoData.name_Jeff}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Jeff, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Jeff}
                                        </Button>}
                                    />
                                </Card>


                                <Card
                                    style={{ float: 'left', width: '200px', marginLeft: '12px', marginTop: '10px' }}
                                    cover={<div>    <div className="font-face-gm"
                                        style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px' }}>
                                        {MoreInfoData.title_Chi}</div>
                                        <img width="120"
                                            alt={MoreInfoData.name_Chi}
                                            src={MoreInfoData.image_Chi}

                                        /></div>
                                    }
                                    actions={[
                                        <Button disabled={this.state.loading}
                                            onClick={() => this.handleMoreInfo(MoreInfoData.name_Chi)}
                                            className="font-face-gm"
                                            style={{
                                                minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                            }}
                                            type="link">
                                            {L('About')}
                                        </Button>,
                                        <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Chi, "_blank")} />,
                                    ]}
                                >
                                    <Meta style={{ marginTop: '-20px' }}
                                        avatar={''}
                                        title={<div style={{ marginBottom: '-8px', fontSize: '1.3em', opacity: '0.8' }}
                                            className="font-face-gm">{MoreInfoData.name_Chi}</div>}
                                        description={<Button disabled={this.state.loading}
                                            onClick={() => window.open('mailto:' + MoreInfoData.email_Chi, "_blank")}
                                            className="font-face-gm"
                                            style={{
                                                fontSize: '0.9em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                            }}
                                            type="link">
                                            {MoreInfoData.email_Chi}
                                        </Button>}
                                    />
                                </Card>


                                <br />
                            </div>

                        </Card>
                    </Modal>
                </div>

                <div>
                    <Drawer
                        closable={true}
                        onClose={onCancel}
                        visible={isMobile === true ? (visible === true ? true : false) : false}
                        footer={null}
                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null}>
                       <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
                            {L('Our Team')}
                        </Divider>

                        <Row style={{ marginBottom: '20px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                      
                        <Card
                            style={{ float: 'left', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Ben}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Ben}
                                    src={MoreInfoData.image_Ben}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Ben)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Ben, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{ marginBottom: '-8px', fontSize: '1.1em', opacity: '0.8' }} className="font-face-gm">{MoreInfoData.name_Ben}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Ben, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray', marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Ben}
                                </Button>}
                            />
                        </Card>

                        <Card
                            style={{ float: 'left', marginLeft: '2px', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Mitch}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Mitch}
                                    src={MoreInfoData.image_Mitch}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Mitch)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Mitch, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{
                                    marginBottom: '-8px',
                                    fontSize: '1.1em', opacity: '0.8'
                                }}

                                    className="font-face-gm">{MoreInfoData.name_Mitch}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Mitch, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray',
                                        marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Mitch}
                                </Button>}
                            />
                        </Card>

                        <br />

                        <Card
                            style={{ float: 'left', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Bill}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Bill}
                                    src={MoreInfoData.image_Bill}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Bill)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Bill, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{
                                    marginBottom: '-8px',
                                    fontSize: '1.1em', opacity: '0.8'
                                }}
                                    className="font-face-gm">{MoreInfoData.name_Bill}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Bill, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray',
                                        marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Bill}
                                </Button>}
                            />
                        </Card>

                        <Card
                            style={{ float: 'left', marginLeft: '2px', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Paul}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Paul}
                                    src={MoreInfoData.image_Paul}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Paul)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Paul, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{
                                    marginBottom: '-8px',
                                    fontSize: '1.1em', opacity: '0.8'
                                }}
                                    className="font-face-gm">{MoreInfoData.name_Paul}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Paul, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray',
                                        marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Paul}
                                </Button>}
                            />
                        </Card>

                        <br />

                        <Card
                            style={{ float: 'left', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Jeff}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Jeff}
                                    src={MoreInfoData.image_Jeff}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Jeff)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Jeff, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{
                                    marginBottom: '-8px',
                                    fontSize: '1.1em', opacity: '0.8'
                                }}
                                    className="font-face-gm">{MoreInfoData.name_Jeff}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Jeff, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray',
                                        marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Jeff}
                                </Button>}
                            />
                        </Card>


                        <Card
                            style={{ float: 'left', marginTop: '10px', width: '47%', textAlign: 'center' }}
                            cover={<div>    <div className="font-face-gm"
                                style={{ fontSize: '1.2em', opacity: '0.8', marginTop: '15px', marginBottom: '5px', }}>
                                {MoreInfoData.title_Chi}</div>
                                <img width="120"
                                    alt={MoreInfoData.name_Chi}
                                    src={MoreInfoData.image_Chi}

                                /></div>
                            }
                            actions={[
                                <Button disabled={this.state.loading}
                                    onClick={() => this.handleMoreInfo(MoreInfoData.name_Chi)}
                                    className="font-face-gm"
                                    style={{
                                        minWidth: '85px', height: '30px', fontSize: '1em', color: 'gray'
                                    }}
                                    type="link">
                                    {L('About')}
                                </Button>,
                                <LinkedinOutlined key="edit" onClick={() => window.open(MoreInfoData.linkedIn_Chi, "_blank")} />,
                            ]}
                        >
                            <Meta style={{ marginTop: '-20px' }}
                                avatar={''}
                                title={<div style={{
                                    marginBottom: '-8px',
                                    fontSize: '1.1em', opacity: '0.8'
                                }}
                                    className="font-face-gm">{MoreInfoData.name_Chi}</div>}
                                description={<Button disabled={this.state.loading}
                                    onClick={() => window.open('mailto:' + MoreInfoData.email_Chi, "_blank")}
                                    className="font-face-gm"
                                    style={{
                                        fontSize: '0.7em', opacity: '0.8', color: 'gray',
                                        marginBottom: '-10px',
                                    }}
                                    type="link">
                                    {MoreInfoData.email_Chi}
                                </Button>}
                            />
                        </Card>

                        <div>&nbsp;</div>

                        <Drawer
                            closable={this.props.isMobile === true ? true : false}
                            onClose={() => this.setState({ subDrawerVisible: false })}
                            visible={this.state.subDrawerVisible}
                            footer={null}
                            width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                            title={null} >
                           <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
                                {this.state.currentInfoName}
                            </Divider>
                            <Row style={{ marginBottom: '20px' }}>
                                <Progress
                                    strokeColor={{
                                        from: this.props.secondaryColor,
                                        to: this.props.primaryColor,
                                    }}
                                    showInfo={false}
                                    percent={100}
                                    status="normal"
                                    size={'small'}
                                />
                            </Row>

                            <Card bordered={false}>

                                <Card
                                    style={{ float: 'left', marginLeft: '60px', marginTop: '-15px', textAlign: 'center', width: '180px', fontSize: '0.9em' }}
                                    cover={
                                        <img width="100"
                                            alt={this.state.currentInfoName}
                                            src={this.state.currentInfoImage}

                                        />
                                    }

                                >
                                    <Meta className="font-face-gm"
                                        avatar={''}
                                        title={<div style={{ fontSize: '0.8em' }}>{this.state.currentInfoTitle}</div>}
                                        description={this.state.currentInfoEmail}
                                    />
                                </Card>

                            </Card>

                            <Card className="font-face-gm" bordered={false} style={{ opacity: '0.5' }}  >

                                {this.state.currentInfoText}

                            </Card>

                        </Drawer>

                    </Drawer>
                </div>


                <div>
                    <Drawer
                        closable={this.props.isMobile === true ? true : false}
                        onClose={() => this.setState({ modalDrawerVisible: false })}
                        visible={this.state.modalDrawerVisible}
                        footer={null}
                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null}  >
                       <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
                            {this.state.currentInfoName}
                        </Divider>
                        <Row style={{ marginBottom: '20px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                        <Card bordered={false}>

                            <Card
                                style={{ float: 'left', marginLeft: '70px', marginTop: '-15px', textAlign: 'center', width: '180px', fontSize: '0.9em' }}
                                cover={
                                    <img width="120"
                                        alt={this.state.currentInfoName}
                                        src={this.state.currentInfoImage}

                                    />
                                }

                            >
                                <Meta className="font-face-gm"
                                    avatar={''}
                                    title={<div style={{ fontSize: '0.8em' }}>{this.state.currentInfoTitle}</div>}
                                    description={this.state.currentInfoEmail}
                                />
                            </Card>

                        </Card>

                        <Card className="font-face-gm" bordered={false} style={{ opacity: '0.5' }}  >

                            {this.state.currentInfoText}

                        </Card>
                    </Drawer>
                </div>


            </div>
        );
    }

}

export default OurTeam;